export {
    Type,
    toBase58,
    fromBase58,
    toBuffer,
    fromBuffer,
    getAlias,
    isAlias,
    toSchemaValue,
    fromSchemaValue,
    equals,
    SchemaValue,
    toTypedJSON,
    toUnwrappedJSON,
    fromTypedJSON,
    JSON_DISCRIMINATOR,
    Serializable,
    instanceOf,
    fromJSON,
} from '../../types/AccountAddress.js';
